// @wc-ignore-file
/**
 * `KeyboardEvent.key` values the app compares against.
 *
 * These are DATA, not UI text. They live in their own `@wc-ignore-file` module
 * because wuchale extracts any capital-initial string literal out of a
 * non-ignored module and rewrites it into a catalog lookup — under fr/de `event.key === "Escape"`
 * would then compare against the translated string and silently stop matching
 * (CR-82, then CR-170: Enter/Escape/arrow handlers broke for French and German
 * users). Every key comparison — `===`, `switch` case, allow-list — imports
 * from here instead of inlining the literal: the ESLint rule
 * `local/no-key-name-literal` (frontend/eslint-rules/) rejects an inline key name
 * outside this module and test files, and `keyboard-keys.test.ts` fails if a key
 * name ever reappears as a live msgid in the catalogs.
 */
export const KEY_ENTER = "Enter";
export const KEY_ESCAPE = "Escape";
export const KEY_TAB = "Tab";
export const KEY_BACKSPACE = "Backspace";
export const KEY_DELETE = "Delete";
export const KEY_SPACE = " ";
export const KEY_ARROW_LEFT = "ArrowLeft";
export const KEY_ARROW_RIGHT = "ArrowRight";
export const KEY_ARROW_UP = "ArrowUp";
export const KEY_ARROW_DOWN = "ArrowDown";
export const KEY_HOME = "Home";
export const KEY_END = "End";
export const KEY_PAGE_UP = "PageUp";
export const KEY_PAGE_DOWN = "PageDown";

/** Keys a read-only editor preview still lets through: scrolling, focus moves and leaving. */
export const READ_ONLY_NAVIGATION_KEYS: ReadonlySet<string> = new Set([
  KEY_ARROW_LEFT,
  KEY_ARROW_RIGHT,
  KEY_ARROW_UP,
  KEY_ARROW_DOWN,
  KEY_PAGE_UP,
  KEY_PAGE_DOWN,
  KEY_HOME,
  KEY_END,
  KEY_TAB,
  KEY_ESCAPE,
]);
